export default __webpack_public_path__ + "static/media/user-blue.5db2f68f.svg";